<template>
  <div class="modal-wrapper">
    <BasicModal
      :title="'使い方'"
      :isShowModal=isShowModal
      :canCancel="true"
      @cancel="cancel">
      <div class="accordion-container">
        <div class="top-description">
          <p>ここで設定した内容に応じて訪問者に対して自動スカウトを送付することができます。
          </p>
        </div>
        <section class="accordion-wrapper disp-scroll">
          <b-collapse
            class="card"
            animation="slide"
            v-for="(collapse, index) of collapses"
            :key="index"
            :open="isOpen == index"
            @open="isOpen = index">
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              role="button">
              <p class="card-header-title">
                {{ collapse.title }}
              </p>
              <a class="card-header-icon">
                <b-icon
                  :icon="props.open ? 'menu-down' : 'menu-up'">
                </b-icon>
              </a>
            </div>
            <div class="card-content">
              <div class="content">
                {{ collapse.text }}
              </div>
            </div>
          </b-collapse>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'

export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    const collapses = [
      {
        title: 'スカウト種類',
        text: '表示する自動スカウトを選択できます。'
      },
      {
        title: 'スカウト先URL',
        text: 'ここに入力した内容とURLの一部が一致した場合のみスカウトが適用されます。入力がない場合は全アイコン設置先に自動スカウトが適用されます。'
      },
      {
        title: 'セグメント',
        text: '自動スカウトを適用するセグメントを指定できます。'
      },
      {
        title: '訪問回数',
        text: '自動スカウトを適用する訪問回数を指定できます。'
      },
      {
        title: '滞在時間',
        text: '自動スカウトを適用する滞在時間を指定できます。'
      },
      {
        title: 'ロボとの会話',
        text: '自動スカウトを適用するロボとの会話状況を指定できます。'
      },
    ]
    return {
      collapses: collapses,
      isOpen: -1,
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .accordion-container {
    padding: 16px;
  }
  .accordion-wrapper {
    height: 480px;
    padding: 8px;
  }
  .top-description {
    margin-bottom: 16px;
    text-align: left;
    font-size: 14px;
  }
  .card-header-title {
    font-size: 12px;
  }
  .card-content {
    .content {
      text-align: left;
      font-size: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/modals/ModalHowToUseAutoScout.vue